export default __webpack_public_path__ + "static/media/Snd_P_Starts.dbc073d4.mp3";